module.exports = __webpack_public_path__ + "img/landing.559818a4.png";